import { apiInitialState } from '../../../utils/apiStateUtils';

export default {
    keyword: null,
    insightsApiData: apiInitialState(),
    numericInsightsApi: apiInitialState()
};